var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56741 9.43254C5.56754 9.74598 5.31342 10.0001 5.00011 10C4.84876 10 4.70522 9.94026 4.59883 9.83388C4.49245 9.7275 4.43271 9.58396 4.43271 9.43265L4.4328 5.56737L0.567457 5.56735C0.416141 5.56735 0.272605 5.5076 0.166226 5.40122C0.059911 5.29491 0.000125992 5.15142 4.75597e-08 5.0001C-0.00012693 4.68674 0.254019 4.43261 0.567311 4.43274L4.43271 4.43276L4.43269 0.567455C4.43257 0.254021 4.68669 -0.000126948 5 4.75734e-08C5.3135 -6.68776e-06 5.5674 0.253868 5.56739 0.567349L5.56741 4.43274L9.43265 4.43265C9.74612 4.43265 10 4.68653 10 4.99991C10.0001 5.31334 9.74601 5.56749 9.43269 5.56737L5.56739 5.56745L5.56741 9.43254Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.64e5bf0f.svg";
export { ForwardRef as ReactComponent };